export const initialState = {
  loggedIn: false,
}

export const reducer = (state, action) => {
  switch (action.type) {
    case 'login':
      return {
        ...state,
        loggedIn: true,
      }

    case 'logout':
      return {
        ...state,
        loggedIn: false,
      }

    default:
      return state
  }
}
